import { Component, OnInit } from '@angular/core';
import { DemandReductionDataService, DemandReductionReach } from '../../../../services/demand-reduction-data.service';


@Component({
  selector: 'app-demand-reduction-container',
  templateUrl: './demand-reduction-container.component.html',
  styleUrls: ['./demand-reduction-container.component.scss']
})
export class DemandReductionContainerComponent {

    demandReductionData: DemandReductionReach[];

    constructor(private demandReduction: DemandReductionDataService) {}

    ngOnInit(){

    this.demandReduction.currentDemandReduction.subscribe(demandReductionData => {
        this.demandReductionData = demandReductionData;
      });
    }

}